const menuButton = document.querySelector('.menu-toggle');
const navLinks = document.querySelector('.nav-links');
const siteHeaderElement = document.querySelector('.site-header');

const brandGreatPattern = /\bgreat\b/i;
const brandGreatGlobalPattern = /\bgreat\b/gi;
const brandGreatExcludedElements = 'script, style, noscript, textarea, input, select, option, code, pre, svg, [aria-hidden="true"], [data-no-brand-highlight], .brand-word-great';

function highlightBrandGreatTextNode(textNode) {
  if (!textNode?.nodeValue || !brandGreatPattern.test(textNode.nodeValue)) return;

  const parent = textNode.parentElement;
  if (!parent || parent.closest(brandGreatExcludedElements)) return;

  const fragment = document.createDocumentFragment();
  let cursor = 0;

  textNode.nodeValue.replace(brandGreatGlobalPattern, (word, offset) => {
    fragment.append(textNode.nodeValue.slice(cursor, offset));

    const highlight = document.createElement('span');
    highlight.className = 'brand-word-great';
    highlight.textContent = word;
    fragment.append(highlight);

    cursor = offset + word.length;
    return word;
  });

  fragment.append(textNode.nodeValue.slice(cursor));
  textNode.replaceWith(fragment);
}

function highlightBrandGreat(root = document.body) {
  if (!root) return;
  if (root.nodeType === Node.TEXT_NODE) {
    highlightBrandGreatTextNode(root);
    return;
  }
  if (root.nodeType !== Node.ELEMENT_NODE || root.matches(brandGreatExcludedElements)) return;

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const textNodes = [];

  while (walker.nextNode()) {
    if (brandGreatPattern.test(walker.currentNode.nodeValue || '')) textNodes.push(walker.currentNode);
  }

  textNodes.forEach(highlightBrandGreatTextNode);
}

highlightBrandGreat();

const brandGreatObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach(highlightBrandGreat);
  });
});

if (document.body) {
  brandGreatObserver.observe(document.body, { childList: true, subtree: true });
}

if (menuButton && navLinks) {
  const syncMobileMenuOffset = () => {
    if (!siteHeaderElement) return;
    document.documentElement.style.setProperty('--mobile-nav-top', `${Math.max(0, siteHeaderElement.getBoundingClientRect().bottom)}px`);
  };

  menuButton.addEventListener('click', () => {
    const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
    if (!isOpen) syncMobileMenuOffset();
    menuButton.setAttribute('aria-expanded', String(!isOpen));
    menuButton.setAttribute('aria-label', isOpen ? 'Open menu' : 'Close menu');
    navLinks.classList.toggle('open', !isOpen);
    document.body.classList.toggle('menu-open', !isOpen);
  });

  navLinks.addEventListener('click', (event) => {
    if (!event.target.closest('a')) return;
    menuButton.setAttribute('aria-expanded', 'false');
    menuButton.setAttribute('aria-label', 'Open menu');
    navLinks.classList.remove('open');
    document.body.classList.remove('menu-open');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || menuButton.getAttribute('aria-expanded') !== 'true') return;
    menuButton.setAttribute('aria-expanded', 'false');
    menuButton.setAttribute('aria-label', 'Open menu');
    navLinks.classList.remove('open');
    document.body.classList.remove('menu-open');
    menuButton.focus();
  });

  window.addEventListener('resize', syncMobileMenuOffset, { passive: true });
}

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const revealItems = document.querySelectorAll('.reveal');

if (reducedMotion) {
  revealItems.forEach((item) => item.classList.add('in'));
} else if (revealItems.length) {
  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('in');
      observer.unobserve(entry.target);
    });
  }, { threshold: .12 });
  revealItems.forEach((item) => revealObserver.observe(item));
}

const productImage = document.querySelector('#product-image');
const galleryButtons = document.querySelectorAll('[data-gallery-src]');

function showProductImage(src, alt) {
  if (!productImage || !src) return;
  productImage.classList.add('is-switching');
  window.setTimeout(() => {
    productImage.removeAttribute('srcset');
    productImage.removeAttribute('sizes');
    productImage.src = src;
    productImage.alt = alt || productImage.alt;
    productImage.classList.remove('is-switching');
  }, 140);
}

function selectGalleryImage(src) {
  if (!src) return;
  const matchingThumb = [...galleryButtons].find((button) => button.dataset.gallerySrc === src);
  galleryButtons.forEach((button) => button.setAttribute('aria-pressed', String(button === matchingThumb)));
  matchingThumb?.scrollIntoView({
    behavior: reducedMotion ? 'auto' : 'smooth',
    block: 'nearest',
    inline: 'center'
  });
}

galleryButtons.forEach((button) => {
  button.addEventListener('click', () => {
    galleryButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
    showProductImage(button.dataset.gallerySrc, button.dataset.galleryAlt);
  });
});

const productForm = document.querySelector('[data-product-form]');

const recipeFilterGroup = document.querySelector('[data-recipe-filters]');
const recipeCards = [...document.querySelectorAll('[data-recipe-products]')];
const storyGallery = document.querySelector('[data-story-gallery]');

if (storyGallery) {
  const storySlides = [...storyGallery.querySelectorAll('[data-story-slide]')];
  const storyDots = [...storyGallery.querySelectorAll('[data-story-dot]')];
  const storyPrev = storyGallery.querySelector('[data-story-prev]');
  const storyNext = storyGallery.querySelector('[data-story-next]');
  const storyCount = storyGallery.querySelector('[data-story-count]');
  const storyStatus = storyGallery.querySelector('[data-story-status]');
  let activeStorySlide = 0;
  let storyTimer;

  function showStorySlide(index) {
    activeStorySlide = (index + storySlides.length) % storySlides.length;

    storySlides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === activeStorySlide;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', String(!isActive));
    });

    storyDots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === activeStorySlide;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-pressed', String(isActive));
    });

    if (storyCount) storyCount.textContent = String(activeStorySlide + 1).padStart(2, '0');
    if (storyStatus) {
      const caption = storySlides[activeStorySlide]?.querySelector('figcaption strong')?.textContent.trim();
      storyStatus.textContent = `Photo ${activeStorySlide + 1} of ${storySlides.length}: ${caption}`;
    }
  }

  function stopStoryAutoplay() {
    window.clearInterval(storyTimer);
  }

  function startStoryAutoplay() {
    stopStoryAutoplay();
    if (!reducedMotion) {
      storyTimer = window.setInterval(() => showStorySlide(activeStorySlide + 1), 5200);
    }
  }

  storyPrev?.addEventListener('click', () => {
    showStorySlide(activeStorySlide - 1);
    startStoryAutoplay();
  });
  storyNext?.addEventListener('click', () => {
    showStorySlide(activeStorySlide + 1);
    startStoryAutoplay();
  });
  storyDots.forEach((dot) => {
    dot.addEventListener('click', () => {
      showStorySlide(Number(dot.dataset.storyDot));
      startStoryAutoplay();
    });
  });
  storyGallery.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      showStorySlide(activeStorySlide - 1);
      startStoryAutoplay();
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      showStorySlide(activeStorySlide + 1);
      startStoryAutoplay();
    }
  });
  storyGallery.addEventListener('mouseenter', stopStoryAutoplay);
  storyGallery.addEventListener('mouseleave', startStoryAutoplay);
  storyGallery.addEventListener('focusin', stopStoryAutoplay);
  storyGallery.addEventListener('focusout', startStoryAutoplay);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stopStoryAutoplay();
    else startStoryAutoplay();
  });

  showStorySlide(0);
  startStoryAutoplay();
}

if (recipeFilterGroup && recipeCards.length) {
  const filterButtons = [...recipeFilterGroup.querySelectorAll('[data-recipe-filter]')];
  const filterStatus = recipeFilterGroup.querySelector('[data-recipe-filter-status]');
  const filterEmpty = document.querySelector('[data-recipe-filter-empty]');
  const filterEmptyTitle = filterEmpty?.querySelector('[data-recipe-filter-empty-title]');

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const selectedFilter = button.dataset.recipeFilter;
      let visibleRecipes = 0;

      filterButtons.forEach((item) => {
        const isActive = item === button;
        item.classList.toggle('active', isActive);
        item.setAttribute('aria-pressed', String(isActive));
      });

      recipeCards.forEach((card) => {
        const products = card.dataset.recipeProducts.split(' ').filter(Boolean);
        const isVisible = selectedFilter === 'all' || products.includes(selectedFilter);
        card.hidden = !isVisible;
        if (isVisible) visibleRecipes += 1;
      });

      if (filterStatus) {
        const label = button.textContent.trim();
        filterStatus.textContent = selectedFilter === 'all'
          ? `Showing all ${visibleRecipes} recipes`
          : `Showing ${visibleRecipes} ${label} ${visibleRecipes === 1 ? 'recipe' : 'recipes'}`;
        if (filterEmpty) {
          const showEmpty = selectedFilter !== 'all' && visibleRecipes === 0;
          filterEmpty.hidden = !showEmpty;
          if (showEmpty && filterEmptyTitle) filterEmptyTitle.textContent = `${label} recipes are coming soon.`;
        }
      }
    });
  });
}

if (productForm) {
  const quantity = productForm.elements.quantity;
  const price = document.querySelector('[data-product-price]');
  const optionNote = document.querySelector('[data-product-option-note]');
  const variantInput = productForm.querySelector('[data-variant-id]');
  const addButton = productForm.querySelector('.add-cart');
  const errorMessage = productForm.querySelector('[data-product-error]');
  const variantsElement = document.querySelector('[data-product-variants]');
  const variants = variantsElement ? JSON.parse(variantsElement.textContent) : [];

  function selectedOptions() {
    const controls = [...productForm.querySelectorAll('[data-option-position]')];
    return controls
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
      .map((control) => {
        if (control.matches('select')) return control.value;
        return control.querySelector('input:checked')?.value;
      });
  }

  function updateProduct() {
    const chosen = selectedOptions();
    const variant = chosen.length
      ? variants.find((item) => item.options.every((value, index) => value === chosen[index]))
      : variants[0];
    const canPurchase = Boolean(variant?.available && !variant?.blocked);
    const displayImage = variant?.image;

    if (variantInput) variantInput.value = variant?.id || '';
    if (price) price.textContent = variant?.price || 'Unavailable';
    if (optionNote) optionNote.textContent = chosen.filter(Boolean).join(' · ');
    if (displayImage) {
      showProductImage(displayImage, document.querySelector('#product-title')?.textContent);
      selectGalleryImage(displayImage);
    }

    if (addButton) {
      addButton.disabled = !canPurchase;
      addButton.textContent = variant?.blocked
        ? 'Contact us for pricing'
        : variant?.available
          ? 'Add to cart'
          : 'Sold out';
    }
    if (errorMessage) {
      errorMessage.hidden = true;
      errorMessage.textContent = '';
    }
  }

  productForm.querySelectorAll('[data-option-position] input, select[data-option-position]').forEach((control) => {
    control.addEventListener('change', updateProduct);
  });

  productForm.querySelectorAll('[data-quantity-change]').forEach((button) => {
    button.addEventListener('click', () => {
      const next = Math.min(99, Math.max(1, Number(quantity.value || 1) + Number(button.dataset.quantityChange)));
      quantity.value = next;
    });
  });

  productForm.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!variantInput?.value || addButton.disabled) return;

    const originalText = addButton.textContent;
    addButton.disabled = true;
    addButton.textContent = 'Adding…';

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantInput.value), quantity: Number(quantity.value || 1) }]
        })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'This item could not be added.');

      addButton.textContent = `Added ${quantity.value} to cart ✓`;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('[data-cart-count]').forEach((count) => {
            count.textContent = cart.item_count;
          });
          const cartLink = document.querySelector('.shop-pill');
          if (cartLink) cartLink.setAttribute('aria-label', `Cart with ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`);
        }
      } catch (_) {
        // The item is already in the cart; a count-refresh failure should not invite a duplicate add.
      }
      window.setTimeout(() => {
        addButton.textContent = originalText;
        addButton.disabled = false;
      }, 1800);
    } catch (error) {
      if (errorMessage) {
        errorMessage.textContent = error.message;
        errorMessage.hidden = false;
      }
      addButton.textContent = originalText;
      addButton.disabled = false;
    }
  });

  updateProduct();
}

const contactParams = new URLSearchParams(window.location.search);
const inquirySelect = document.querySelector('[data-inquiry-select]');
const productSelect = document.querySelector('[data-product-select]');
if (inquirySelect && contactParams.get('inquiry')) inquirySelect.value = contactParams.get('inquiry');
if (productSelect && contactParams.get('product')) productSelect.value = contactParams.get('product');
if (inquirySelect && productSelect) {
  const productField = productSelect.closest('[data-product-field]');
  const syncContactProductField = () => {
    const isDistribution = inquirySelect.value === 'distribution';
    if (productField) productField.hidden = isDistribution;
    productSelect.disabled = isDistribution;
    if (isDistribution) productSelect.value = '';
  };
  inquirySelect.addEventListener('change', syncContactProductField);
  syncContactProductField();
}

const intro = document.querySelector('#intro');
const introMark = document.querySelector('#introMark');
const introReveal = document.querySelector('#introReveal');
const introCue = document.querySelector('#introCue');
const siteHeader = document.querySelector('#siteHeader');
const showcase = document.querySelector('.showcase');
const productTrack = document.querySelector('#productTrack');
const progressDots = document.querySelectorAll('#progress i');

if (intro && introMark && introReveal && siteHeader) {
  const isMobile = () => window.innerWidth <= 680;

  function introTick() {
    if (reducedMotion) {
      siteHeader.classList.add('show');
      return;
    }
    const scrollDistance = intro.offsetHeight - window.innerHeight;
    const progress = Math.min(Math.max(-intro.getBoundingClientRect().top / scrollDistance, 0), 1);
    const firstPhase = Math.min(progress / .45, 1);
    introMark.style.transform = `scale(${1 - .5 * firstPhase}) translateY(${-40 * firstPhase}px)`;
    introMark.style.opacity = 1 - firstPhase;
    const secondPhase = Math.min(Math.max((progress - .4) / .35, 0), 1);
    const fadeOut = Math.min(Math.max((progress - .9) / .1, 0), 1);
    introReveal.style.opacity = secondPhase * (1 - fadeOut);
    introReveal.style.transform = `translateY(${30 - 30 * secondPhase}px)`;
    if (introCue) introCue.style.opacity = 1 - progress * 2.2;
    siteHeader.classList.toggle('show', progress >= .98);
  }

  function sizeShowcase() {
    if (!showcase || !productTrack || reducedMotion || isMobile()) {
      if (showcase) showcase.style.height = 'auto';
      return;
    }
    const distance = productTrack.scrollWidth - window.innerWidth;
    showcase.style.height = `${window.innerHeight + distance}px`;
  }

  function showcaseTick() {
    if (!showcase || !productTrack || reducedMotion || isMobile()) return;
    const rect = showcase.getBoundingClientRect();
    const distance = productTrack.scrollWidth - window.innerWidth;
    const progress = Math.min(Math.max(-rect.top / (showcase.offsetHeight - window.innerHeight), 0), 1);
    productTrack.style.transform = `translateX(${-distance * progress}px)`;
    const lastIndex = Math.max(progressDots.length - 1, 0);
    const index = Math.min(Math.floor(progress * progressDots.length), lastIndex);
    progressDots.forEach((dot, dotIndex) => dot.classList.toggle('on', dotIndex <= index));
  }

  function onScroll() {
    introTick();
    showcaseTick();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => {
    sizeShowcase();
    onScroll();
  });
  sizeShowcase();
  onScroll();
}
